export default "__VITE_ASSET__593d8a06__"